import { db } from '../firebase/config.ts';
import { doc, getDoc, setDoc } from 'firebase/firestore';

const SETTINGS_DOC_ID = 'dashboard_settings';

export interface DashboardSettings {
  fieldOrder: string[];
}

export const DEFAULT_FIELD_ORDER = [
  'event_type',
  'type',
  'category',
  'startDateTime',
  'endDateTime',
  'title',
  'description',
  'place',
  'address',
  'lat_long',
  'price',
  'event_url',
  'poster_url',
  'trailer_url',
  'Image_gallery_url',
  'isPublic',
  'userId',
  'user_name',
  'hostID',
  'likes',
  'comments',
  'shares',
  'createdAt',
  'updatedAt'
];

export const settingsService = {
  async getFieldOrder(): Promise<string[]> {
    try {
      const settingsRef = doc(db, 'settings', SETTINGS_DOC_ID);
      const settingsSnap = await getDoc(settingsRef);
      
      if (settingsSnap.exists()) {
        const data = settingsSnap.data() as DashboardSettings;
        return data.fieldOrder || DEFAULT_FIELD_ORDER;
      }
      
      return DEFAULT_FIELD_ORDER;
    } catch (error) {
      console.error('Error loading field order:', error);
      return DEFAULT_FIELD_ORDER;
    }
  },

  async saveFieldOrder(fieldOrder: string[]): Promise<void> {
    try {
      const settingsRef = doc(db, 'settings', SETTINGS_DOC_ID);
      await setDoc(settingsRef, {
        fieldOrder,
        updatedAt: new Date().toISOString()
      } as DashboardSettings);
    } catch (error) {
      console.error('Error saving field order:', error);
      throw error;
    }
  }
};

export default settingsService;
